import * as App from '@/types/app';
import * as Database from '@/types/database';
import { useFirestore } from '@/services';
import { defineFirebaseCollectionStoreModule } from './base-module';

const { useMaterialOperators } = useFirestore();
export const materialsModule = defineFirebaseCollectionStoreModule<App.Material, Database.Material>(useMaterialOperators);
